export default "__VITE_ASSET__BTA7rZ$d__"